import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/search', label: 'Search Properties' },
    { to: '/listings/new', label: 'List Property' },
    { to: '/concierge', label: 'Property Help' },
  ];

  return (
    <nav className="bg-[#0A3D2F] text-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/veedumparambum-emblem-logo.svg"
              alt="Veedum Parambum"
              className="h-10 w-10 rounded-full object-contain"
            />
            <span className="text-2xl font-semibold tracking-tight">VeedumParambum</span>
          </Link>

          <div className="hidden md:flex items-center gap-8 text-sm font-medium">
            {navLinks.map((link) => (
              <Link key={link.to} to={link.to} className="hover:text-[#C5A36E] transition-colors">
                {link.label}
              </Link>
            ))}

            {user ? (
              <div className="flex items-center gap-3">
                <Link to="/dashboard" className="hover:text-[#C5A36E] transition-colors">Dashboard</Link>
                <button onClick={logout} className="px-4 py-1.5 text-sm border border-white/30 rounded-full hover:bg-white/10 transition">
                  Logout
                </button>
              </div>
            ) : (
              <Link to="/login" className="px-5 py-2 bg-[#C5A36E] text-[#0A3D2F] rounded-full font-semibold hover:bg-white transition">
                Login
              </Link>
            )}
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-white"
            aria-label="Toggle menu"
          >
            {isOpen ? '✕' : '☰'}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/20">
            <div className="flex flex-col gap-4 pt-4 text-sm font-medium">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="py-1 hover:text-[#C5A36E] transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              {user ? (
                <>
                  <Link to="/dashboard" onClick={() => setIsOpen(false)} className="py-1">Dashboard</Link>
                  <button onClick={() => { logout(); setIsOpen(false); }} className="text-left py-1 text-red-400">Logout</button>
                </>
              ) : (
                <Link to="/login" onClick={() => setIsOpen(false)} className="px-5 py-2.5 bg-[#C5A36E] text-[#0A3D2F] rounded-full font-semibold text-center">
                  Login
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
